<template>
  <div>
    <b-card no-body>
      <b-tabs card>
        <b-tab :title="$t('global.tracking')" active>
          <div class="row d-flex justify-content-center mb-70 mt-2 px-2">	
            <div class="col-md-12" v-if="!error">
              <div class="main-card mb-3">
                <b-overlay no-wrap :show="loading"></b-overlay>
                <b-row>
                  <b-col class="mb-2" sm="12" lg="6">
                    <!-- Service info -->
                    <b-card tag="article" class="mb-2 card-custom">
                      <b-card-text>
                        <div class="d-flex justify-content-between">
                          <h5 class="font-weight-bolder">{{ $t('bookings.service') }}</h5>
                          <h5 class="text-muted font-weight-light">#{{ ride.serviceNumber }}</h5>
                        </div>

                        <div class="d-flex justify-content-between">
                          <div>{{ $t('bookings.salesChannelReference') }}</div>
                          <div class="text-muted font-weight-light">
                            {{ ride.salesChannelReference }}
                          </div>
                        </div>

                        <div class="d-flex justify-content-between">
                          <div>{{ $t('bookings.client') }}</div>
                          <div class="text-muted font-weight-light">
                            {{ reservation.client.firstName +" "+ reservation.client.lastName }}
                          </div>
                        </div>

                        <div class="d-flex justify-content-between">
                          <div>{{ $t('bookings.pickupDatetime') }}</div>
                          <div class="text-muted font-weight-light">
                            {{ ride.pickupDatetime }}
                          </div>
                        </div>

                        <div class="d-flex justify-content-between">
                          <div><span class="text-danger font-weight-bolder">(A)</span>
                            {{ $t('bookings.pickup') }}
                          </div>
                          <div class="text-muted font-weight-light">
                            {{ pickupNamed }}
                          </div>
                        </div>

                        <div class="d-flex justify-content-between">
                          <div><span class="text-danger font-weight-bolder">(B)</span>
                            {{ $t('bookings.dropoff') }}
                          </div>
                          <div class="text-muted font-weight-light">
                            {{ dropoffNamed }}
                          </div>
                        </div>
                      </b-card-text>
                    </b-card>
                    <!-- End service info -->
                  </b-col>
                    
                  <b-col sm="12" lg="6">
                    <!-- Assign driver section -->
                    <label>{{ $t('bookings.driver') }}:</label>
                    <b-input-group>
                      <template #prepend>
                        <b-button
                          variant="outline-info"
                          @click="showNewDriverForm">
                          <md-icon :icon="'person_add'"></md-icon>
                        </b-button>
                      </template>

                      <b-form-select
                        :options="driversOpts"
                        v-model="driverSelected">
                      </b-form-select>

                      <template #append>
                        <b-button
                          variant="outline-primary"
                          @click="actions('assignDriver')">
                          {{ $t('bookings.assign') }} {{ $t('bookings.driver') }}
                        </b-button>
                      </template>                       
                    </b-input-group>
                    <!-- End Assign driver section -->
                  </b-col>
                </b-row>

                  <b-row>
                    <b-col class="col-md-12">
                      <!-- Render google map -->
                      <g-map :ref="'map-tracking-status'" v-if="logsTrackStatus.length>0" @mounted="gmapMounted()"></g-map>
                      <div class="main-card">

                        <b-overlay :show="loading" no-wrap rounded></b-overlay>
                        <div v-if="logsTrackStatus.length==0 && !loading" class="text-center">
                          <label  class="text-center">
                            {{ $t('global.ajaxTable.noRecordsFound') }}
                          </label>
                        </div>
        
                        <b-table v-else 
                          :items="logsTrackStatus" 
                          :fields ="colsTableLogs" 
                          class="mt-3"
                          striped
                          hover
                          responsive
                          bordered
                          stacked="lg"
                          small>

                          <!-- A virtual column -->
                          <template #cell(index)="data">
                            <div class="text-center">
                              <span class="text-danger font-weight-bolder">({{ data.index + 1 }})</span>
                            </div>
                          </template>

                          <template #cell(transportServiceTrackingStatus)="row">
                            {{  $t('bookings.trackingStatusOpts.'+row.item.transportServiceTrackingStatus) }}
                          </template>

                          <template #cell(creationDatetime)="row">
                            <date-label :date="row.item.creationDatetime"/>
                          </template>
                        </b-table>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row v-if="false">
                    <b-col class="col-md-5 mx-auto mt-2">
                      <b-col class="text-center">
                        <span>{{ $t('bookings.trackingStatus') }}</span><br />
                        <b-badge pill variant="primary" class="p-2">{{
                          trackingStatusActual.text
                        }}</b-badge
                        ><br />
                        <md-icon
                          :icon="'keyboard_double_arrow_down'"
                        ></md-icon>
                      </b-col>
                      <b-form-checkbox
                        id="checkbox-1"
                        class="text-center"
                        v-if="trackingStatusActual.value == 'atPickup'"
                        v-model="noShow"
                      >
                        No show
                      </b-form-checkbox>
                      <b-button
                        v-if="!islastStatus"
                        class="mt-1"
                        variant="outline-primary"
                        block
                        @click="showMsgBox()"
                        >Actualizar a :
                        <b>{{ trackingStatusNext.value }}</b></b-button
                      >
                    </b-col>
                  </b-row>
                </div>

                <b-alert
                  variant="warning"
                  v-if="alert.show"
                  show
                  class="text-center"
                  dismissible
                >
                  {{ alert.text }}
                </b-alert>
              </div>
              <div class="col">
                <b-alert variant="danger" v-if="error" show class="text-center">
                  {{ $t('messages.errorTrackingModule') }}
                </b-alert>
              </div>
            </div>
          </b-tab>
          <b-tab :title="$t('tracking.driverChat')" v-if="false">
            <div class="p-2">
        <DriverChat :transportServiceId="ride.id"></DriverChat>
      </div>
          </b-tab>
      </b-tabs>
    </b-card>

    <b-modal
      :header-bg-variant="'info'"
      hide-footer
      ref="new-driver"
      size="md"
      :title="$t('users.newDriver')"
    >
      <driverForm @saved="driverSaved" />
    </b-modal>

   </div>
</template> 
<script>
import api from "../../../../api.js"
import gMap from "./Map"
import driverForm from "./FormNewDriver"
import DateLabel from "../../../helpers/DateLabel"
import DriverChat from "./DriverChat"

export default {
  name: "trackingForm",
  components: { gMap, driverForm, DateLabel, DriverChat },
  props: {
    index: Number,
    ride: Object,
    reservation: Object
  },
  data() {
    const modelDriver = {fullName: '', id: ''}
    return {
      error: false,
			modelDriver: modelDriver,
			loading: false,
			dataDrivers: [],
			driverInternal: { ...modelDriver }, //SC driver
			driverExternal: { ...modelDriver }, //booking spreaded
			trackStatusLogs:[],
			applyExternal: false,
			tsTimeZone:null,
			driverSelectedOption: "",
			alert: { show: false, text: "" },
			noShow: false,
			colsTableLogs: [
        { key: 'index', label: this.$t('bookings.points') },
				{ key: 'transportServiceTrackingStatus', label: this.$t('bookings.trackingStatus') },
				{ key: 'creationDatetime', label: this.$t('bookings.pickupDatetime') + ' UTC' },
				{ key: 'creationDatetimeLocal', label: this.$t('bookings.pickupDatetime')},
				{ key: 'latitude', label: 'Lat.' },
				{ key: 'longitude', label: 'Lng.' },
				{ key: 'driverName', label: this.$t('bookings.driver') },
			]
    }
  },
  methods: {
    fetchAssignedData() {
      this.resetDistributed()
      this.loading = true

      api(this)
        .get("/tracking/driver/assigned/" + this.ride.id)
				.then(res => {
					this.applyExternal   = res.data.applyExternal;
          this.driverExternal  = res.data.driverExternal;
					this.driverInternal  = res.data.driverInternal;
					this.trackStatusLogs = res.data.logsTrackingStatus;
			})
      .catch((err) => {
        this.$root.handleRequestError(err)
				close()
      })
			.finally(() => {
				this.loading = false;
      });
    },
    fetchDrivers() {
      this.dataDrivers = [];
			this.loading     = true;

      api(this)
				.get("/tracking/supplier/drivers")
				.then(res => {
					this.dataDrivers = res.data;
				})
        .catch((err) => {
          this.$root.handleRequestError(err)
          close()
        })
				.finally(() => {
					this.loading = false;
				})
    },
    resetDistributed() {
      this.applyExternal   = false;
			this.driverExternal  = { ...this.modelDriver }
			this.driverInternal  = { ...this.modelDriver }
			this.trackStatusLogs = []
    },
    gmapMounted(){
			this.$refs["map-tracking-status"].createMarks(this.gMarks)
		},
    showNewDriverForm() {
			this.$refs["new-driver"].show();
		},
    hideNewDriverForm() {
			this.$refs["new-driver"].hide();
		},
    actions(action) {
			let filters = { transportServiceId: this.ride.id };
			switch (action) {
				case "updateStatus":
					if (this.islastStatus) {
						this.$root.showAlert("Opción no valida", {
							variant: "danger"
						});
						return;
					}
					filters["trackingStatus"] = this.trackingStatusNext.value;
					break;
				case "assignDriver":
					if (this.driverSelectedOption == "") {
						this.$root.showAlert("Seleccione un conductor", {
							variant: "danger"
						});
						return;
					}
					if (this.driverSelectedOption === "default") {
						action = "restartDriver";
					}
					filters["driverId"] = this.driverSelectedOption;
					break;
				default:
					this.$root.showAlert("Opción no valida", {
						variant: "danger"
					});
					return;
			}

			this.loading = true;
			this.alert   = { show: false, text: "" };

			api(this)
				.post("/tracking/actions/" + action, filters)
				.then(res => {
					let payload = {};
					switch (action) {
						case "updateStatus":
							payload = {
								index: this.index,
								data: {
									trackingStatus: this.trackingStatusNext
										.value
								}
							};

							this.SET_UPDATE_TRANSPORT_SERVICE(payload);
							
              break;
						case "assignDriver":
						case "restartDriver":
							setTimeout(() => {
								this.fetchAssignedData();
							}, 0);
							break;
					}
					this.$root.showAlert("Realizado con exito");
					if ("alert" in res.data) {
						this.alert = { show: true, text: res.data.alert[0] };
					}
				})
				.catch(this.$root.handleRequestError)
				.finally(() => {
					this.loading = false;
				});
		},
    showMsgBox() {
			this.boxTwo = "";
			this.$bvModal
				.msgBoxConfirm("¿Esta seguro que desea cambiar el status?.", {
					title: "Confirmación",
					size: "sm",
					buttonSize: "sm",
					okVariant: "primary",
					okTitle: "Si",
					cancelTitle: "Cancelar",
					footerClass: "p-2",
					hideHeaderClose: false,
					centered: false
				})
				.then(value => {
					if (value === true) {
						this.actions("updateStatus");
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
    driverSaved(dataDriver) {
			this.fetchDrivers()
			this.driverInternal = {
				id: dataDriver.id,
				fullName: dataDriver.fullName
			};
			this.hideNewDriverForm()
		}
  },
  computed: {
    supplierId() {
			return this.$root.store.state.currentSystem.system.id
		}
  },
  beforeCreate() {
    this.$options.computed = {
      logsTrackStatus() {
        return this.trackStatusLogs
      },
      pickupNamed() {
        let pickup = this.ride.pickup.name
        return pickup.substring(0, 45)
      },
      dropoffNamed() {
        let dropoff = this.ride.dropoff.name
        return dropoff.substring(0, 45)
      },
      gMarks() {
        let arrayDriverTrack = [];

        let pp = {...this.ride.pickup};
        pp.label   = "A";
        pp.content = pp.name;
        let dp = {...this.ride.dropoff};
        dp.label   = "B";
        dp.content = dp.name;
        arrayDriverTrack.push(pp,dp);

        this.trackStatusLogs.forEach((item,index)=>{
          let itemMark  = {...item};
          itemMark.label=  (index+1).toString();
          itemMark.content= item.transportServiceTrackingStatus+"<br>"+item.creationDatetimeLocal;
          arrayDriverTrack.push(itemMark);
        })

        return arrayDriverTrack;
      },
      driversOpts() {
				let opts = [
					{ value: "default", text: this.$t('bookings.assignDriverDefault') }
				];
				this.dataDrivers.forEach(element => {
					opts.push({
						value: element.id,
						text: element.fullName
					});
				});
				return opts;
			},
      driverSelected: {
				get: function() {
          if (this.driverInternal == null) return null
					return this.driverInternal.id;
				},
				set: function(val) {
					this.driverSelectedOption = val;
				}
			},
      trackingStatusActual() {
				return this.$root.getItemFromAuxVarOpts(
					"transportServiceTrackingStatusOpts",
					this.ride.trackingStatus
				);
			},
      trackingStatusNext() {
				let opts = [
					...this.$root.auxVars.transportServiceTrackingStatusOpts
				];
				let indexActual = opts.findIndex(el => {
					return el.value == this.ride.trackingStatus;
				});
				if (this.noShow) {
					let indexNoShow = opts.findIndex(el => {
						return el.value == "noShow";
					});
					return opts[indexNoShow];
				} else {
					let nextIndex = indexActual + 1;
					return opts[nextIndex];
				}
			},
			islastStatus() {
				return (
					this.ride.trackingStatus == "finished" ||
					this.ride.trackingStatus == "noShow"
				);
			},
      placesRide() {
				return [{...this.ride.pickup},{...this.ride.dropoff}]
			},
    }
  },
  mounted() {
    this.fetchAssignedData()
    this.fetchDrivers()
  }
}
</script>

<style scoped>
  .card-custom {
    border-radius: 1rem;
  }
</style>